import { type PropertyAttributeTypeId, PropertySchemaType } from "~/common/types";

import type { PropertySchemaAssociationFormData } from "~/features/admin/propertySchemas/types";

export function buildNewAssociation(
  propertyAttributeTypeId: PropertyAttributeTypeId | undefined = undefined,
  propertyTypeId: PropertySchemaType = PropertySchemaType.String,
  position = 0,
): PropertySchemaAssociationFormData {
  return {
    id: undefined,
    name: "",
    required: false,
    unique: false,
    position,
    propertyAttributeTypeId,
    propertySchema: {
      id: undefined,
      propertyTypeId,
      selectOptions: [],
    },
  };
}
